import { AxiosInstance } from 'axios'
import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import { OpenWeatherResponseType } from '@/utilities/weather/services/openWeatherApi/types/OpenWeatherResponseType'
import OpenWeatherIcon from '@/utilities/weather/services/openWeatherApi/OpenWeatherIcon'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'

export default class ForecastProvider extends AbstractWeatherService {
  private readonly baseUrl: string

  constructor(apiKey: string, httpClient: AxiosInstance, baseUrl: string) {
    super(apiKey, httpClient)

    this.baseUrl = baseUrl
  }

  async getInfo({ lat, lng }: CoordinateType, date: Dayjs): Promise<WeatherType> {
    const url = `${this.baseUrl}/onecall`

    const params = new URLSearchParams({
      appid: this.apiKey,
      lat: String(lat),
      lon: String(lng),
      exclude: 'hourly,minutely,current',
      units: 'metric',
    })

    const { data } = await this.httpClient.get<OpenWeatherResponseType>(`${url}?${params.toString()}`)

    const current = data?.daily?.find(({ dt }) => date.isSame(dt * 1000, 'day'))
    const weather = current?.weather?.at(0)

    if (!weather) {
      throw new Error('Invalid response')
    }

    return {
      title: weather.main,
      description: weather.description,
      icon: new OpenWeatherIcon(weather.icon).getIcon(),
      temp: current?.temp?.day ?? 0,
    }
  }
}
